import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import TextField from '@material-ui/core/TextField';
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import SingleButton from "../../components/SingleButton";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from "moment";

class StageTam6003EntryCalendar extends React.Component {

    constructor(props){
        super(props);
        // console.log( "FNX: Stage0Welcome props");
        // console.log(props);
        this.state = { selectedOption: '', value: '', hideShowButtonClass: 'showButtons' }
    }

    handleOnChange = (e) =>  {
        console.log('selected option', e.target.value);
        this.setState({ selectedOption: e.target.value});
    }

	/**
	 * textarea on change handling
	 * @param e
	 */
	handleOnChangeTextarea = (e) =>  {
        console.log('textarea value', e.target.value);
        this.setState({ value: e.target.value});
    }
	
	/**
	 * Hide Button bar when display keyboard on mobile devices
	 * @param e
	 */
	hideButtonBar = (e) => {
		this.setState({ hideShowButtonClass: 'hideButtons'});
	}
	
	/**
	 * Show Button bar when hide keyboard on mobile devices
	 * @param e
	 */
	showButtonBar = (e) => {
		this.setState({ hideShowButtonClass: 'showButtons'});
	}

    /**
     * render
     * @returns {*}
     */
    render() {

        let WelcomeText;
        if(this.props.validationDone){
            WelcomeText = <Header
				textResource={"tam6003_entry_calendar_title"}
				name={`${this.props.apiData.firstName}`}
			/>
		}else{
			WelcomeText = <Header
				textResource={"tam6003_entry_calendar_title"}
				name={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
			/>
		}

		const headerAndWelcomeText = <div>
			{WelcomeText}
			<div style={{marginTop:"20px"}}>
				<TextBody
					textResource={"tam6003_entry_calendar_body_1"}
					emoji_up = "&#128077;"
				/>
			</div>
		</div>;

		const statusBar = <StatusOverview
			showDescription={true}
		/>;

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

		return <Container>
			<MobileView>
				<Row className={"header"}>
					<Col xs={2} style={{marginLeft:"-15px"}}>
						<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
					</Col>
				</Row>
				<Row style={{paddingTop:"5vh"}}>
					<Col xs={{ size: 12 }}>
						{headerAndWelcomeText}

						<div style={{marginTop:"20px"}}>
							<TextBody
								textResource={"tam6003_entry_calendar_body_2"}
								emoji_up = "&#128077;"
							/>
						</div>
						<TextField
							id={"textarea_comment"}
							className={"width-100 myInputField myTextarea"}
							type={"text"}
							multiline
							rowsMax={4}
							value={this.state.value}
							onChange={this.handleOnChangeTextarea}
							placeholder={" "}
							onFocus={this.hideButtonBar}
							onBlur={this.showButtonBar}
						/>

						<Row className={'fixed-to-bottom'} style={{paddingBottom:"20px"}}>
							<Col xs={{ size: 12 }}>
								<BottomBar
									// mainButtonOnClick={this.props.nextStage}
									mainButtonOnClick={() => {
										// return text area value (Response_Hinweis_Techniker)
										this.props.commonSubmitCallback(this.state.value)
									}}
									mainButtonTextResource={"tam6003_entry_calendar_button"}
									className={this.state.hideShowButtonClass}
								/>
							</Col>
						</Row>
					</Col>
				</Row>
			</MobileView>

			<BrowserView>
				<Row className={"header desktop"}>
					<Col xs={12}>
						<div className={"container"}>
							<Row>
								<Col xs={2} style={{marginLeft:"-15px"}}>
									<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
				<Row style={{paddingTop:"20vh"}}>
					<Col xs={{ size: 10, offset: 1 }}>

						{headerAndWelcomeText}

					</Col>
				</Row>
				<Row>
					<Col xs={{ size: 4, offset: 1 }}>
						<div className={"margin-16"} />
						<div>
							<TextBody
								textResource={"tam6003_entry_calendar_body_2"}
								emoji_up = "&#128077;"
							/>
						</div>
						<TextField
							id={"textarea_comment"}
							className={"width-100 myInputField myTextarea"}
							type={"text"}
							multiline
							rowsMax={4}
							value={this.state.value}
							onChange={this.handleOnChangeTextarea}
							placeholder={" "}
						/>
						<div className={"margin-16"} />
						<SpacerRow/>
					</Col>
				</Row>
				<Row>
					<Col xl={{ size: 3, offset: 1 }} lg={{ size: 3, offset: 1 }} md={{ size: 4, offset: 1 }} sm={{ size: 6, offset: 1 }} xs={{ size: 12, offset: 0 }} >
						<BottomBar
							// mainButtonOnClick={this.props.nextStage}
							mainButtonOnClick={() => {
								// return text area value (Response_Hinweis_Techniker)
								this.props.commonSubmitCallback(this.state.value);
							}}
							mainButtonTextResource={"tam6003_entry_calendar_button"}
						/>
					</Col>
				</Row>
			</BrowserView>
		</Container>
	}
}

export default translate("translations")(StageTam6003EntryCalendar);